// react-accessibility-provider re-exports the version of react-accessibility-id-context from this package.
// This happens so that when an application has `@nerdwallet/react-accessibility-provider`
// installed at the top of its dependency tree, `useId(..)` will always import this single IdContext
// no matter how many duplicate copies of `@nerdwallet/react-accessibility` exist.
//
// SSRProvider uses this particular IdContext to inject the deterministic id-generator into context
import IdContext, { defaultContext } from '@nerdwallet/react-accessibility-id-context';
export default IdContext;
export { defaultContext };